import styled, { css } from 'styled-components'

export const Container = styled.div`
  flex-direction: column;
  width: 400px;
  max-height: 500px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  overflow-y: auto;
  padding: 25px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.secondary};
`
export const Title = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 22px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
`
